<template>
  <div class="verification">
    <div class="verification__image--small verification__image--failed"
         :class="failedReason === 'failed' ? 'verification__image--failed' : 'verification__image--warning'"></div>
    <h3 class="verification__title">{{ title }}</h3>
    <p class="verification__description">{{ description }}</p>
    <button class="verification__button sk-btn sk-btn--default"
            @click="verify">{{ $gettext('BankID') }}</button>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex';

  export default {
    props: {
      failedReason: {
        type: String,
        default: ''
      },
    },
    computed: {
      ...mapGetters('UserInfoStore', ['userEmail']),
      title() { return this.failedReason == 'failed' ? this.$gettext('Access denied') : this.$gettext('Identities don\'t match'); },
      description() {
        switch (this.failedReason) {
          case 'failed':
            return this.$gettext('Sorry, we weren\'t able to verify your identity. Please, try again.');

          case 'failed-not-matched': {
            const template = this.$gettext('Your identity does not match with the account %{email}. Please contact customer support, or try again with a matching BankID.');
            return this.$gettextInterpolate(template, {email: this.userEmail});
          }

          case 'failed-linked-with-other-account':
            return this.$gettext('Your identity is already linked with another account. Please contact customer support, or try again with another BankID.');

          default:
            return '';
        }
      }
    },
    methods: {
      verify() { this.$emit('verify'); }
    }
  };
</script>
